import MomentUtils from "@date-io/moment";

export const DATE_DISPLAY_FORMAT = "DD MMMM YYYY";

export class OurCustomUtils extends MomentUtils {
    getDatePickerHeaderText(date: any) { //override
        return date.format(DATE_DISPLAY_FORMAT);
    }
}


// WEBPACK FOOTER //
// ./src/components/date-display-format.ts